import { createStyles } from '@mantine/core'

export default createStyles((theme, _params, getRef) => ({
  title: {
    width: '100%',
    margin: 0,
  },

  close: {
    position: 'absolute',
    right: '20px',
    top: '20px',
    color: theme.colors.dark,
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0%',
    minHeight: 0,
    height: '100%',
  },

  body: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0%',
  },
}))
